import { useTheme, useMediaQuery } from "@mui/material";
export const useCurrentBreakpoint = () => {
    const theme = useTheme();
    //Remove "container" from the list of breakpoints as it's not yet implemented
    const breakpoints = theme.breakpoints.keys.filter((k) => k !== "container");
    const matches = breakpoints.map((bp) => useMediaQuery(theme.breakpoints.up(bp)));
    // Iterate in reverse order to get the largest matching breakpoint first
    for (let i = breakpoints.length - 1; i >= 0; i--) {
        if (matches[i]) {
            return { key: breakpoints[i], value: theme.breakpoints.values[breakpoints[i]] };
        }
    }
    // Fallback to the smallest breakpoint if none match
    return { key: breakpoints[0], value: theme.breakpoints.values[breakpoints[0]] };
};
